import React from 'react'
import './Carousel.css';


export default function Carousel() {
    return (
        <div className='container-fluid mt-5'>
            <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img src="https://cdn.pixabay.com/photo/2024/03/12/20/32/bitcoin-8629504_640.jpg" className="d-block w-100" alt="..." />
                        <div className="carousel-caption d-none d-md-block">
                            <h1>World's Fastest Growing Crypto App</h1>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <img src="https://image.cnbcfm.com/api/v1/image/106893887-1623167512779-bitcoin-digital-crypto-currency-with-stock-market-candlesticks-on-computer-screen-rltheis_t20_W7xVwY.jpg?v=1623167564&w=1600&h=900" className="d-block w-100" alt="..." />
                        <div className="carousel-caption d-none d-md-block">
                            <h1>Buying and selling 250+ cryptocurrencies at true cost</h1>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <img src="https://fortune.com/img-assets/wp-content/uploads/2021/12/Crypto2022-e1639060907323.jpg?resize=1200,600" className="d-block w-100" alt="..." />
                        <div className="carousel-caption d-none d-md-block">
                            <h1>SECURELY BUY, SELL, STORE, SEND and TRACK</h1>
                        </div>
                    </div>
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
            <div className='divider'>
                
            </div>
            {/* <div className='loader'>
                <h1 className='text'>Cryptocurrency Prices by Market Cap</h1>
            </div> */}
        </div>
    )
}
